import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { GlobalStyles } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Moment from 'moment';
import { getActiveLanguage } from '@haldor/ui';
import { getNormalizedActiveLanguage, getPickersLocale } from '../../../helpers/locale';

/**
 * StartEndInputs
 * Props:
 * - input: { name, value, onChange } (react-final-form) OR you can pass value/onChange directly
 * - name
 * - value: { start: string, end: string }
 * - onChange: function(updatedValue)
 * - disabled: boolean
 * - labels: { startLabel, endLabel } optional
 * - error: boolean (shows red border when true)
 */
var StartEndInputs = function StartEndInputs(props) {
  var input = props.input,
    name = props.name,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    labels = props.labels,
    error = props.error;
  var current = input && input.value || value || {
    start: '',
    end: ''
  };
  var emitChange = function emitChange(next) {
    if (input && input.onChange) {
      input.onChange(next);
    }
    if (onChange) onChange(next);
  };
  var setField = function setField(field, v) {
    var next = _objectSpread(_objectSpread({}, current || {
      start: '',
      end: ''
    }), {}, _defineProperty({}, field, v));
    emitChange(next);
  };

  // prefer explicit labels passed in `labels`, otherwise use static defaults
  var finalStartLabel = labels && labels.startLabel || 'Start Date';
  var finalEndLabel = labels && labels.endLabel || 'End Date';

  // determine locale using Moment (we use Moment for parsing/formatting)
  var active = getActiveLanguage();
  Moment.locale(active);

  // compute inputFormat similar to DatePickers.getDateFormat using Moment
  var getDateFormat = function getDateFormat() {
    var fmt = Moment.localeData(active).longDateFormat('L') || 'YYYY-MM-DD';
    fmt = fmt.replace('YYYY', 'yyyy');
    fmt = fmt.replace('DD', 'dd');
    return fmt;
  };
  var inputFormat = getDateFormat();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    styles: {
      '.MuiPickersPopper-root': {
        zIndex: 1000000000 + ' !important'
      }
    }
  }), /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterMoment,
    adapterLocale: getNormalizedActiveLanguage(),
    localeText: function (_pl$components) {
      var pl = getPickersLocale(getNormalizedActiveLanguage());
      return (pl === null || pl === void 0 || (_pl$components = pl.components) === null || _pl$components === void 0 || (_pl$components = _pl$components.MuiLocalizationProvider) === null || _pl$components === void 0 || (_pl$components = _pl$components.defaultProps) === null || _pl$components === void 0 ? void 0 : _pl$components.localeText) || undefined;
    }()
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    gap: 2,
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: finalStartLabel,
    value: current.start ? Moment(current.start, 'YYYY-MM-DD') : null,
    onChange: function onChange(date) {
      var val = date ? date.format('YYYY-MM-DD') : '';
      setField('start', val);
    },
    disabled: disabled,
    maxDate: current.end ? Moment(current.end, 'YYYY-MM-DD') : undefined,
    slots: {
      textField: TextField
    },
    slotProps: {
      textField: {
        fullWidth: true,
        error: error
      }
    }
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: finalEndLabel,
    value: current.end ? Moment(current.end, 'YYYY-MM-DD') : null,
    onChange: function onChange(date) {
      var val = date ? date.format('YYYY-MM-DD') : '';
      setField('end', val);
    },
    disabled: disabled,
    minDate: current.start ? Moment(current.start, 'YYYY-MM-DD') : undefined,
    slots: {
      textField: TextField
    },
    slotProps: {
      textField: {
        fullWidth: true,
        error: error
      }
    }
  })))));
};
export default StartEndInputs;